import React from "react";
import { useWindowResize } from "hooks";

const Map = () => {
  const { width } = useWindowResize();
  const isMobile = width <= 1023;

  return (
    <div className="mapouter">
      <div className="gmap_canvas">
        <iframe
          title="devta"
          width="100%"
          height={isMobile ? "200" : "320"}
          id="gmap_canvas"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.4523363886783!2d106.65734251020784!3d-6.203907093757969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f9213c0335c9%3A0x409f42227fb075ac!2sPT.%20Devta%20Raih%20Cita!5e0!3m2!1sid!2sid!4v1752041147104!5m2!1sid!2sid"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        />
      </div>
    </div>
  );
};

export default Map;
